import { useCallback, useState } from "preact/hooks";
import axios from "axios";


export default function useAxiosCallback() {

    const [isLoading, setIsLoading] = useState(false);

    const onAxiosRequest = () => setIsLoading(false);

    const setAxiosRequest = useCallback((url, config = { method: "GET" }, onSuccessCallback, onErrorCallback) => {
        setIsLoading(true);

        const selectedConsumerId = localStorage.getItem('selectedConsumerId');

        const enhancedConfig = { ...config };

        if (selectedConsumerId && selectedConsumerId !== 'null') {
            if (!enhancedConfig.params) {
                enhancedConfig.params = {};
            }
            enhancedConfig.params.consumer_id = selectedConsumerId;

            if (!enhancedConfig.headers) {
                enhancedConfig.headers = {};
            }
            enhancedConfig.headers['x-consumer-id'] = selectedConsumerId;
        }

        return axios(url, enhancedConfig).then(onSuccessCallback).catch(onErrorCallback).finally(onAxiosRequest);
    }, []);

    return { isLoading, fetch: setAxiosRequest };
}